import React from 'react';
import SvgIcon from './SvgIcon';
import iconsPaths from '../../../data/iconsPaths';

const GenericIcon = ({
  width, height, size, ...props
}) => {
  const iconPath = iconsPaths.find((ip) => ip.icon === props.fromIconPath);
  if (!iconPath) return null;

  let calculatedWidth = iconPath.width;
  let calculatedHeight = iconPath.height;
  if (size) {
    calculatedWidth = iconPath.width > iconPath.height
      ? size
      : size * (iconPath.height / iconPath.width);
    calculatedHeight = iconPath.height > iconPath.width
      ? size
      : size * (iconPath.width / iconPath.height);
  } else if (width && height) {
    calculatedWidth = width;
    calculatedHeight = height;
  } else if (width && !height) {
    calculatedWidth = width;
    calculatedHeight = width * (iconPath.height / iconPath.width);
  } else if (!width && height) {
    calculatedHeight = height;
    calculatedWidth = height * (iconPath.width / iconPath.height);
  }

  return (
    <SvgIcon
      paths={iconPath.iconPaths}
      width={calculatedWidth}
      height={calculatedHeight}
      viewBoxWidth={iconPath.viewBoxWidth || calculatedWidth}
      viewBoxHeight={iconPath.viewBoxHeight || calculatedHeight}
      {...props}
    />
  );
};

export const IconArrowcircle = (props) => <GenericIcon fromIconPath="IconArrowcircle" {...props} />;

export const IconDashboard = (props) => <GenericIcon fromIconPath="IconDashboard" {...props} />;

export const IconShare = (props) => <GenericIcon fromIconPath="IconShare" {...props} />;

export const IconRightArrow = (props) => <GenericIcon fromIconPath="IconRightArrow" {...props} />;

export const IconUserGroup = (props) => <GenericIcon fromIconPath="IconUserGroup" {...props} />;

export const IconUserEuro = (props) => <GenericIcon fromIconPath="IconUserEuro" {...props} />;

export const IconCashBag = (props) => <GenericIcon fromIconPath="IconCashBag" {...props} />;

export const IconPoliss = (props) => <GenericIcon fromIconPath="IconPoliss" {...props} />;

export const IconArrowTop = (props) => <GenericIcon fromIconPath="IconArrowTop" {...props} />;

export const navbarMenuRight = (props) => <GenericIcon fromIconPath="navbarMenuRight" {...props} />;

export const IconNavbarUser = (props) => <GenericIcon fromIconPath="IconNavbarUser" {...props} />;

export const IconNavbarBell = (props) => <GenericIcon fromIconPath="IconNavbarBell" {...props} />;

export const IconNavbarFullscrean = (props) => <GenericIcon fromIconPath="IconNavbarFullscrean" {...props} />;

export const IconCollapse = (props) => <GenericIcon fromIconPath="IconCollapse" {...props} />;

export const IconInfo = (props) => <GenericIcon fromIconPath="IconInfo" {...props} />;

export const IconNavbarMenuLines = (props) => <GenericIcon fromIconPath="IconNavbarMenuLines" {...props} />;

export const IconNavbarSearch = (props) => <GenericIcon fromIconPath="IconNavbarSearch" {...props} />;

export const IconUserMenuSettingsCog = (props) => <GenericIcon fromIconPath="IconUserMenuSettingsCog" {...props} />;

export const IconUserMenuShare = (props) => <GenericIcon fromIconPath="IconUserMenuShare" {...props} />;

export const IconUserMenuFAQ = (props) => <GenericIcon fromIconPath="IconUserMenuFAQ" {...props} />;

export const IconUserMenuLogout = (props) => <GenericIcon fromIconPath="IconUserMenuLogout" {...props} />;

export const IconDashboardFiles = (props) => <GenericIcon fromIconPath="IconDashboardFiles" {...props} />;

export const IconCalendar = (props) => <GenericIcon fromIconPath="IconCalendar" {...props} />;

export const IconLocation = (props) => <GenericIcon fromIconPath="IconLocation" {...props} />;

export const IconMobile = (props) => <GenericIcon fromIconPath="IconMobile" {...props} />;

export const IconEmail = (props) => <GenericIcon fromIconPath="IconEmail" {...props} />;

export const IconFacebook = (props) => <GenericIcon fromIconPath="IconFacebook" {...props} />;

export const IconInstagram = (props) => <GenericIcon fromIconPath="IconInstagram" {...props} />;

export const IconLinkedin = (props) => <GenericIcon fromIconPath="IconLinkedin" {...props} />;

export const IconTwitter = (props) => <GenericIcon fromIconPath="IconTwitter" {...props} />;

export const IconPen = (props) => <GenericIcon fromIconPath="IconPen" {...props} />;

export const IconDelete = (props) => <GenericIcon fromIconPath="IconDelete" {...props} />;

export const IconCheckMarkCircle = (props) => <GenericIcon fromIconPath="IconCheckMarkCircle" {...props} />;

export const IconCircle = (props) => <GenericIcon fromIconPath="IconCircle" {...props} />;

export const IconPig = (props) => <GenericIcon fromIconPath="IconPig" {...props} />;

export const IconModalClose = (props) => <GenericIcon fromIconPath="IconModalClose" {...props} />;

export const IconPigLarge = (props) => <GenericIcon fromIconPath="IconPigLarge" {...props} />;

export const IconPigNew = (props) => <GenericIcon fromIconPath="IconPigNew" {...props} />;

export const IconArrowDown = (props) => <GenericIcon fromIconPath="IconArrowDown" {...props} />;

export const IconCheckedSmall = (props) => <GenericIcon fromIconPath="IconCheckedSmall" {...props} />;

export const IconArrowNext = (props) => <GenericIcon fromIconPath="IconArrowNext" {...props} />;

export const IconArrowPrevious = (props) => <GenericIcon fromIconPath="IconArrowPrevious" {...props} />;

export const IconUserLargeGrey = (props) => <GenericIcon fromIconPath="IconUserLargeGrey" {...props} />;

export const IconPlus = (props) => <GenericIcon fromIconPath="IconPlus" {...props} />;

export const IconLocation2 = (props) => <GenericIcon fromIconPath="IconLocation2" {...props} />;

export const IconStar = (props) => <GenericIcon fromIconPath="IconStar" {...props} />;

export const IconShareLarge = (props) => <GenericIcon fromIconPath="IconShareLarge" {...props} />;

export const NewIconPig = (props) => <GenericIcon fromIconPath="NewIconPig" {...props} />;

export const IconFilterTb = (props) => <GenericIcon fromIconPath="IconFilterTb" {...props} />;

export const IconExportTb = (props) => <GenericIcon fromIconPath="IconExportTb" {...props} />;

export const IconArrowBottom = (props) => <GenericIcon fromIconPath="IconArrowBottom" {...props} />;

export const IconTrash = (props) => <GenericIcon fromIconPath="IconTrash" {...props} />;

export const IconUpload = (props) => <GenericIcon fromIconPath="IconUpload" {...props} />;

export const IconSelectArrow = (props) => <GenericIcon fromIconPath="IconSelectArrow" {...props} />;

export const IconCross = (props) => <GenericIcon fromIconPath="IconCross" {...props} />;

export const IconFooterUser = (props) => <GenericIcon fromIconPath="IconFooterUser" {...props} />;

export const IconFooterVideoChat = (props) => <GenericIcon fromIconPath="IconFooterVideoChat" {...props} />;

export const IconFooterCall = (props) => <GenericIcon fromIconPath="IconFooterCall" {...props} />;

export const IconFooterFaceToFace = (props) => <GenericIcon fromIconPath="IconFooterFaceToFace" {...props} />;

export const IconFooterEmail = (props) => <GenericIcon fromIconPath="IconFooterEmail" {...props} />;

export const IconModalClosePlain = (props) => <GenericIcon fromIconPath="IconModalClosePlain" {...props} />;

export const IconCheckOutline = (props) => <GenericIcon fromIconPath="IconCheckOutline" {...props} />;

export const IconEye = (props) => <GenericIcon fromIconPath="IconEye" {...props} />;

export const IconEyeSlash = (props) => <GenericIcon fromIconPath="IconEyeSlash" {...props} />;

export const IconSmileySmile = (props) => <GenericIcon fromIconPath="IconSmileySmile" {...props} />;

export const IconSmileyHappy = (props) => <GenericIcon fromIconPath="IconSmileyHappy" {...props} />;

export const IconSmileySad = (props) => <GenericIcon fromIconPath="IconSmileySad" {...props} />;
